const CONFIG = {
    MODE: process.env.REACT_APP_MODE,
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
    REQUEST_TIMEOUT: process.env.REACT_APP_REQUEST_MAX_TIMEOUT,
    BITESHIP_API_ENDPOINT: process.env.REACT_APP_BITESHIP_API_ENDPOINT,
    HOME_URL: process.env.REACT_APP_HOME_URL,
}

export default CONFIG
